<div class="container-dialog">

  <app-dialog-header (backClick)="onBackClick()" [header]="header"></app-dialog-header>

  <div class="content">
    <h2 class="panel-title">{{('Modules.Licenses.List.Filter' | translate)}}</h2>
    <app-search-bar [title]="'Components.SearchBar.Title' | translate"
      [placeholder]="'Components.SearchBar.Placeholder' | translate"
      (onSearchTextChanged)="onSearchTextChanged($event)"></app-search-bar>

    <ng-container *ngIf="companies?.length > 0; then licensesList else noStoreLicenses"></ng-container>
    <ng-template #licensesList>
      <!-- Company -->
      <h2 class="panel-title">{{filteredCompaniesTitle}}</h2>
      <app-basic-list [options]="companies" [(selectedValue)]="selectedCompany" (selectedValueChange)="onSelectedValueChanged()"></app-basic-list>
    </ng-template>

    <div *ngIf="isLoadingFilteredCompanies">
      <mat-spinner class="spinner" diameter="28"></mat-spinner>
    </div>

    <ng-template #noStoreLicenses>
      <ng-container>
        <div *ngIf="!isLoadingFilteredCompanies" class="panel-no-data">
          {{ (searchText.length > 0 ? 'Modules.Licenses.List.NoCompaniesFiltered' : 'Modules.Licenses.List.NoDataCompanies') | translate: { filter: searchText } }}          
        </div>
      </ng-container>
    </ng-template>  

  </div>
</div>